module.exports = __webpack_public_path__ + "img/aviation-code.a26fb68e.jpg";